import {IVideoService} from "./video.service.interface";
import {ServiceBase} from "../ServiceBase";
import {IVideoPlayerViewModel} from "./models/video-player.view-model.interface";
import {VideoStreamingPlayerModel} from "./models/video-streaming/video-streaming-player.model";
import Hls from "hls.js";
import {IServiceFactoryExtended} from "../service-factory-extended.interface";

const VIDEO_STREAM_MIME_TYPE = 'application/vnd.apple.mpegurl';

export class VideoService extends ServiceBase implements IVideoService {
    constructor(services: IServiceFactoryExtended) {
        super(services);
        const videoElement = document.createElement('video');
        this.isStreamingSupported = this.isNativeStreamingSupported(videoElement) || Hls.isSupported();
    }


    get isSoundMuted(): boolean {
        return this.services.user.preferences.sound.isMuted;
    }

    toggleSound(): void {
        this.services.user.preferences.sound.toggle();
    }


    isNativeStreamingSupported(videoElement: HTMLVideoElement): boolean {
        const validCanPlayValue = ['probably', 'maybe'];
        const canPlayResultValue = videoElement.canPlayType(VIDEO_STREAM_MIME_TYPE);

        return validCanPlayValue.includes(canPlayResultValue);
    }

    readonly isStreamingSupported: boolean;


    createVideoStreamingPlayer(): IVideoPlayerViewModel {
        return new VideoStreamingPlayerModel(this.services);
    }


}